import { useQuery } from '@tanstack/react-query';

import { getLikes } from './utils/requests';

export const useFileLikes = ({
  fileId,
  userId,
  queryKey,
  railsType,
  showReactions = true,
}) =>
  useQuery({
    queryKey: [queryKey, fileId],
    queryFn: () => getLikes({ fileId, userId, railsType }),
    enabled: !!fileId && !!userId && !!railsType && showReactions,
    staleTime: Infinity,
  });
